/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Lesson_FormatsInputs */

const en_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesson formats`)
};

const es_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatos de lección`)
};

const de_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterrichtsformate`)
};

const zh_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程形式`)
};

const ar_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنواع الدروس`)
};

const fr_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formats de cours`)
};

const vi_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hình thức bài học`)
};

const sw_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miundo ya somo`)
};

const th_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รูปแบบบทเรียน`)
};

const bs_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formati lekcija`)
};

const ja_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスン形式`)
};

const ko_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 형식`)
};

const pt_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatos de aula`)
};

const it_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formati di lezione`)
};

const sv_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektionsformat`)
};

const nl_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesformaten`)
};

const da_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektionsformater`)
};

const nb_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leksjonsformater`)
};

const fi_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppituntimuodot`)
};

const pl_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formaty lekcji`)
};

const ru_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форматы уроков`)
};

const tr_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders formatları`)
};

const hi_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ प्रारूप`)
};

const id_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format pelajaran`)
};

const ms_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format pelajaran`)
};

const cs_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formáty lekcí`)
};

const el_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μορφές μαθημάτων`)
};

const he_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סוגי שיעורים`)
};

const af_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesformate`)
};

const hu_nav_lesson_formats = /** @type {(inputs: Nav_Lesson_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Óratípusok`)
};

/**
* | output |
* | --- |
* | "Lesson formats" |
*
* @param {Nav_Lesson_FormatsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_lesson_formats = /** @type {((inputs?: Nav_Lesson_FormatsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Lesson_FormatsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_lesson_formats(inputs)
	if (locale === "de") return de_nav_lesson_formats(inputs)
	if (locale === "zh") return zh_nav_lesson_formats(inputs)
	if (locale === "ar") return ar_nav_lesson_formats(inputs)
	if (locale === "fr") return fr_nav_lesson_formats(inputs)
	if (locale === "vi") return vi_nav_lesson_formats(inputs)
	if (locale === "sw") return sw_nav_lesson_formats(inputs)
	if (locale === "th") return th_nav_lesson_formats(inputs)
	if (locale === "bs") return bs_nav_lesson_formats(inputs)
	if (locale === "ja") return ja_nav_lesson_formats(inputs)
	if (locale === "ko") return ko_nav_lesson_formats(inputs)
	if (locale === "pt") return pt_nav_lesson_formats(inputs)
	if (locale === "it") return it_nav_lesson_formats(inputs)
	if (locale === "sv") return sv_nav_lesson_formats(inputs)
	if (locale === "nl") return nl_nav_lesson_formats(inputs)
	if (locale === "da") return da_nav_lesson_formats(inputs)
	if (locale === "nb") return nb_nav_lesson_formats(inputs)
	if (locale === "fi") return fi_nav_lesson_formats(inputs)
	if (locale === "pl") return pl_nav_lesson_formats(inputs)
	if (locale === "ru") return ru_nav_lesson_formats(inputs)
	if (locale === "tr") return tr_nav_lesson_formats(inputs)
	if (locale === "hi") return hi_nav_lesson_formats(inputs)
	if (locale === "id") return id_nav_lesson_formats(inputs)
	if (locale === "ms") return ms_nav_lesson_formats(inputs)
	if (locale === "cs") return cs_nav_lesson_formats(inputs)
	if (locale === "el") return el_nav_lesson_formats(inputs)
	if (locale === "he") return he_nav_lesson_formats(inputs)
	if (locale === "af") return af_nav_lesson_formats(inputs)
	if (locale === "hu") return hu_nav_lesson_formats(inputs)
	return en_nav_lesson_formats(inputs)
});